const DEMOGRAPHICS = {"0-17":"0-17","18-24":"18-24","25-34":"25-34","35-44":"35-44","45-54":"45-54","55-64":"55-64","65+":"65+","18-64":"18-64"};

export { DEMOGRAPHICS }
